import { render, staticRenderFns } from "./WsPocketImagePickerUpload.vue?vue&type=template&id=71dfe0c8&"
import script from "./WsPocketImagePickerUpload.vue?vue&type=script&lang=js&"
export * from "./WsPocketImagePickerUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports